module.exports = __webpack_public_path__ + "static/dagny-italic-5fc6d0cf47c5b93e08460ebf98b3e36b.woff2";